<template>
  <div class="clearfix main_center">

    <div class="content clearfix">

      <customForm
          v-if="customFormShow"
          ref="customFormRef"
          :auditHisTable.sync="auditHisTable"
          :entityId.sync="entityId"
          :categoryCode.sync="categoryCode"
          :baseURL.sync="baseURL">
      </customForm>

      <customFormOther
          v-if="customFormOtherShow"
          ref="customFormOtherRef"
          :auditHisTable.sync="auditHisTable"
          :entityId.sync="entityId"
          :categoryCode.sync="categoryCode"
          :nodeCode.sync="nodeCode"
          :nodeTitle.sync="nodeTitle"
          :purchaserMode.sync="purchaserMode"
      ></customFormOther>

      <el-card class="box-card" v-if="!customFormShow && !customFormOtherShow" style="height: 700px;position: relative;margin-bottom: 10px" >
        <emptyInfo v-if="groupList.length == 0" :emptyMsg="'暂无表单数据'" ></emptyInfo>
      </el-card>


    </div>

  </div>
</template>

<script>
    import customForm from '@/components/customForm';
    import emptyInfo from '@/components/empty-info';
    import customFormOther from '@/components/customForm/customFormOther';
    import {tabsCloseCurrentHandle} from '@/utils/routeTab';
    import {mapState} from "vuex";


    export default {
  components: {
    customForm,
    emptyInfo,
    customFormOther
  },
  data(){
    return{
      id:"",
      baseURL:"",
      categoryCode:"",
      customFormShow:true,
      nodeCode:"",
      nodeTitle:"",
      purchaserMode:"",
      auditHisTable:[],
      customFormOtherShow:false,
      form:{
        id:'',
        historyid:'-1',
        processinstanceid:"",
        processinstancecreatedate:"",
        businessType:"",
        entityId:"",
        flowId:'',
        tenderProjectCode:'',
        bidSectionCode:'',
        projectCode:'',
        personHandle:1,  //人工干预见证
        rejectCode:'',
      },
      listNav:['项目信息','中选信息','附件信息'],
      loading:false,
      user:'',
      pageSize:10,//每页条数
      pageIndex:1,//当前页
      total:0,//总条数
      processSubmit:false,
      customFormData:{},
      filingCBtn:false,
      backCBtn:false,
      dataId: 0,
      paramMap: {
        tenderProjectCode: '',
        bidSectionCode: '',
        projectCode:'',
        applyCode:'',
        idcard:''
      },
      formId: '',
      groupList: [],
      formInfo:{},
      tableData:[],
      flowId:'',
      entityId:''


    }
  },

  filters:{

  },
  created(){

  },
  computed: {
    ...mapState({
      stateData:state=>state.user
    }),
    businessType:function () {
      return this.form.businessType;
    },
    processinstanceid:function () {
      return this.form.processinstanceid;
    },

  },

  activated() {

    // $route.query.id为首页通过 url跳转 带过来的参数
    this.flowId = (this.$route.query && this.$route.query.flowId );
    this.entityId = (this.$route.query && this.$route.query.entityId );
    this.paramMap = (this.$route.params && this.$route.params.paramMap );
    this.getDetailById();



  },

  methods:{
    //列表查看进来根据id查询详情
    getDetailById(){
      this.getFormIdByFlowid(this.flowId);
    },

    // 返回
    back(){
      tabsCloseCurrentHandle();
      this.$router.push({
        name:'busWitness_list_'+this.businessType
      })
    },


    getFormIdByFlowid(flowid){
      // 根据jz_businessflow_witness的formid得到sys_flownode_config的form_id
      this.$http.get('/configs/sysFlowNodeConfig/get?id='+flowid).then(res=>{
        if(res.data.code==='1'){
          this.categoryCode = res.data.data.categoryCode;
          this.nodeCode = res.data.data.nodeCode;
          this.nodeTitle = res.data.data.nodeName;
          if(res.data.data.enableCustom == 1){
            this.customFormShow = true;
            this.customFormOtherShow = false;
          }else{
            this.customFormShow = false;
            this.customFormOtherShow = true;
          }
          this.initData( res.data.data.formId);
        }else{
          this.$message({
            type:'error',
            message:res.data.msg
          })
        }

      })
    },





    initData(formid) {

      if (formid=='' || formid === undefined  ) {
        this.$message.error('数据集无效')
        return
      }

      // 支持自定义表单数据
      if(this.customFormShow) {
        const that = this;
        setTimeout(function(){
          that.$refs.customFormRef.getCustomData(formid,that.paramMap);
        },100)

      }
      if(this.customFormOtherShow){ // 定制化表单数据
        const that = this;
        setTimeout(function(){
          that.$refs.customFormOtherRef.getCustomData(formid,that.paramMap,that.nodeCode,that.purchaserMode);
        },100)
      }





    },





  },
  deactivated(){

  },





}
</script>

<style lang="less" scope>


.right-content.busWinessRight{
  width: calc(100% - 160px);
}
.left-content.busWinessLeft{
  .left-navbar{
    width:150px;
    border:none;
  }
}


</style>